import {
  createContext,
  useContext,
} from "@bestowinc/tinkertoy-shell-deps/react";

import { createLoadingSlot, type LoadingSlot } from "./loading-slot";

const LoadingSlotContext = createContext<LoadingSlot | undefined>(undefined);

// Never written to: no loader holds it, so trees without a provided slot
// never show loading state.
const detachedSlot = createLoadingSlot();

export const LoadingSlotProvider = LoadingSlotContext.Provider;

/** The shell's loading slot; a detached, always-empty slot when none is provided. */
export function useLoadingSlot(): LoadingSlot {
  return useContext(LoadingSlotContext) ?? detachedSlot;
}
